import React from "react";

export function getStyles(
  fontSize: number,
  lineHeight: number,
  style?: React.CSSProperties
) {
  let styles = {} as React.CSSProperties;
  if (style) {
    styles = { ...style };
  }
  styles.fontSize = `${fontSize}px`;
  styles.lineHeight = `${lineHeight}px`;
  return styles;
}